"use strict";

var defaultConfig = require("./defaults");
var qs = require("querystringify");

function InitConfig(deps) {
    // Current state
    var config = {};
    var global = null;
    var utils = deps.utils;

    // Setup defaults for the SDK
    var prepareSdkConfig = function (suppliedConfig) {
        if (typeof suppliedConfig.sdk === "undefined") suppliedConfig.sdk = {};
        if (suppliedConfig.app_key) suppliedConfig.sdk.appKey = suppliedConfig.app_key;
        return $.extend(true, {}, defaultConfig.primary.sdk, suppliedConfig.sdk);
    };

    // Merge defaults into passed config
    var setDefaults = function (suppliedConfig) {
        suppliedConfig.sdk = prepareSdkConfig(suppliedConfig);

        var merged = utils.merge(defaultConfig.primary, suppliedConfig);

        return merged;
        // return $.extend(true, {}, defaultConfig.primary, suppliedConfig);
    };

    // Set default formats for native fields
    var setCustomerFieldsNativeFormats = function (config) {
        $.each(config.customer_fields, function (key, field) {
            if (!defaultConfig.customerFieldsNativeFormats[key]) return;
            config.customer_fields[key] = $.extend({}, defaultConfig.customerFieldsNativeFormats[key], field);
        });
        return config;
    };

    // Apply the config presets given a configuration
    var applyConfigPreset = function (localConfig, propertyName, propertyObject) {
        var presetCheck = defaultConfig.presets[propertyName][propertyObject];
        if (presetCheck) return $.extend(true, {}, presetCheck, localConfig);
        return localConfig;
    };

    var applyFullCalendarLocalization = function (newConfig) {
        var localization = newConfig.ui.localization;
        var fullcalendar = newConfig.fullcalendar;

        if(localization && localization.today_button){
            if(!fullcalendar.buttonText){
                fullcalendar.buttonText = {};
            }
            
            fullcalendar.buttonText.today = localization.today_button;
        }

        return newConfig;
    };

    // Prefill customer fields based on URL query string
    var applyPrefillFromUrlGetParams = function (suppliedConfig, urlParams) {
        // $.each(suppliedConfig.customer_fields, function (key) {
        //   if (!urlParams['customer.' + key]) return
        //   suppliedConfig.customer_fields[key].prefilled = urlParams['customer.' + key];
        // });
        // return suppliedConfig
    };

    var setProducts = function (products) {
        this.getConfig().products = products;
    };

    // Setup config
    var parseAndUpdate = function (suppliedConfig) {
        // Extend the default config with supplied settings
        var newConfig = setDefaults(suppliedConfig);

        // Apply presets
        newConfig = applyConfigPreset(newConfig, "timeDateFormat", newConfig.ui.time_date_format);
        newConfig = applyConfigPreset(newConfig, "availabilityView", newConfig.ui.availability_view);

        // Set default formats for native fields
        newConfig = setCustomerFieldsNativeFormats(newConfig);

        // set header button texts and other localization related fullcalendar properties
        newConfig = applyFullCalendarLocalization(newConfig);

        // Check for required settings
        if (!newConfig.resourceId) throw 'A required config setting ("resourceId") was missing';

        // Prefill fields based on query string
        // var urlParams = getGlobal().location && getGlobal().location.search;
        // if (urlParams) newConfig = applyPrefillFromUrlGetParams(newConfig, qs.parse(urlParams));

        // Set new config to instance config
        update(newConfig);

        return config;
    };

    var update = function (passedConfig) {
        config = passedConfig;
    };

    var getConfig = function () {
        return config;
    };

    var setGlobal = function (val) {
        global = val;
    };

    var getGlobal = function (val) {
        return global;
    };

    return {
        parseAndUpdate: parseAndUpdate,
        setDefaults: setDefaults,
        update: update,
        setProducts: setProducts,
        getConfig: getConfig,
        setGlobal: setGlobal,
        getGlobal: getGlobal
    };
}

module.exports = InitConfig;
